import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__body" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = { class: "body" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "body__list--child"
}
const _hoisted_9 = {
  key: 2,
  class: "body__list--hover"
}

import {
  Building07,
  Users03,
  Trash01,
  AlarmClock,
  Clipboard,
  LayoutLeft,
  File06,
  Truck01,
  BookOpen01,
  PieChart01,
  Calendar,
  Laptop01,
  Folder,
  Building05,
  ClipboardCheck,
} from "utruckin-icons";
import { useRoute, useRouter } from "vue-router";
import { ref, Component } from "vue";
import { useNotification } from "@/utils/notification";
import logo from "@/assets/images/logo.svg";
import miniLogo from "@/assets/images/logo-mini.svg";
import { useUserStore } from "@/features/users/user.store";

interface IMainItem {
  name: string;
  router: string;
  icon: Component;
  isVisible: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WidgetSidebar',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const usersStore = useUserStore();
const { pushNotification } = useNotification();

const mainItems: IMainItem[] = [
  {
    name: "All tasks",
    router: "/all-tasks",
    icon: File06,
    isVisible: true,
  },
  {
    name: "My tasks",
    router: "/my-tasks",
    icon: Clipboard,
    isVisible: true,
  },
  {
    name: "Reviews",
    router: "/reviews",
    icon: ClipboardCheck,
    isVisible:
      usersStore.userProfile?.role == "super_admin" ||
      usersStore.userProfile?.role == "admin" ||
      usersStore.userProfile?.role == "supervisor",
  },
  {
    name: "Users",
    router: "/users",
    icon: Users03,
    isVisible: true,
  },
  {
    name: "Companies",
    router: "/companies",
    icon: Building07,
    isVisible: true,
  },
  {
    name: "Drivers",
    router: "/drivers",
    icon: Truck01,
    isVisible: true,
  },
  {
    name: "Shifts",
    router: "/shift",
    icon: Clipboard,
    isVisible: true,
  },
  {
    name: "Work types",
    router: "/work-types",
    icon: File06,
    isVisible: true,
  },
  {
    name: "Archive",
    router: "/archive",
    icon: Trash01,
    isVisible: true,
  },
  {
    name: "Inspections",
    router: "/inspections",
    icon: BookOpen01,
    isVisible: true,
  },
  {
    name: "Providers",
    router: "/provider",
    icon: Laptop01,
    isVisible: usersStore.userProfile?.role == "super_admin",
  },
  {
    name: "Watch list",
    router: "/watch-list",
    icon: AlarmClock,
    isVisible: true,
  },
  {
    name: "Work schedule",
    router: "/work-schedule",
    icon: Calendar,
    isVisible: true,
  },
  {
    name: "Management",
    router: "/management",
    icon: Folder,
    isVisible:
      usersStore.userProfile?.role == "super_admin" ||
      usersStore.userProfile?.role == "admin" ||
      usersStore.userProfile?.role == "supervisor",
  },
  {
    name: "Live statistics",
    router: "/live-stats",
    icon: PieChart01,
    isVisible: true,
  },
];

const isWide = ref<boolean>(true);

const goToPage = (item: IMainItem) => {
  router.push(item.router);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-w-sidebar", isWide.value ? 'wide' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (isWide.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(logo),
              width: "142",
              height: "36",
              alt: "company_logo",
              class: "company__logo"
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _unref(miniLogo),
              width: "24",
              height: "24",
              alt: "company_mini_logo",
              class: "company__logo-mini"
            }, null, 8, _hoisted_4)),
        _createElementVNode("div", {
          class: "header__icon",
          onClick: _cache[0] || (_cache[0] = 
            () => {
              isWide.value = !isWide.value;
            }
          )
        }, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(LayoutLeft))))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(mainItems, (item, index) => {
        return _createElementVNode("div", {
          key: index,
          class: "body__list"
        }, [
          (item.isVisible)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["body__list--item", _unref(route).path == item.router ? 'active' : '']),
                onClick: ($event: any) => (goToPage(item))
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                  class: "icon",
                  size: 20
                })),
                _createTextVNode(" " + _toDisplayString(isWide.value ? item.name : ""), 1)
              ], 10, _hoisted_7))
            : _createCommentVNode("", true),
          (_unref(route).path == item.router)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8))
            : _createCommentVNode("", true),
          (!isWide.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.name), 1))
            : _createCommentVNode("", true)
        ])
      }), 64))
    ])
  ], 2))
}
}

})